"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCaptarCodes = void 0;
const enums_1 = require("./enums");
exports.DefaultCaptarCodes = [
    {
        gridcompanyEAN: '8712423014022',
        gridoperator: 'Enexis E',
        captarCode: '8742010102115',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716871000002',
        gridoperator: 'Liander E',
        captarCode: '8742020102112',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716892000005',
        gridoperator: 'Stedin E',
        captarCode: '8742030102119',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716916000004',
        gridoperator: 'Coteq Netbeheer B.V. E',
        captarCode: '8742090102111',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716912000008',
        gridoperator: 'RENDO Netbeheer  E',
        captarCode: '8742080102114',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716878999996',
        gridoperator: 'Westland Infra Netbeheer E',
        captarCode: '8742070102117',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716859000017',
        gridoperator: 'Liander Noord West Net E',
        captarCode: '8742020102112',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8712423014022',
        gridoperator: 'Enexis G',
        captarCode: '8742010202112',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716871000002',
        gridoperator: 'Liander G',
        captarCode: '8742020202119',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716892000005',
        gridoperator: 'Stedin G',
        captarCode: '8742030202116',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716916000004',
        gridoperator: 'Coteq Netbeheer B.V.G',
        captarCode: '8742090202118',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716912000008',
        gridoperator: 'RENDO Netbeheer G',
        captarCode: '8742080202111',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716878999996',
        gridoperator: 'Westland Infra Netbeheer G',
        captarCode: '8742070202114',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716859000017',
        gridoperator: 'Liander Noord West Net G',
        captarCode: '8742020202119',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716887000003',
        gridoperator: 'ENDINET E',
        captarCode: '8742050102113',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8717154940008',
        gridoperator: 'ENDINET E',
        captarCode: '8742050102113',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8717177000000',
        gridoperator: 'ENDINET E',
        captarCode: '8742050102113',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8717179000015',
        gridoperator: 'ENDINET E',
        captarCode: '8742050102113',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716887000003',
        gridoperator: 'ENDINET G',
        captarCode: '8742050202110',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8717154940008',
        gridoperator: 'ENDINET G',
        captarCode: '8742050202110',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8717177000000',
        gridoperator: 'ENDINET G',
        captarCode: '8742050202110',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8717179000015',
        gridoperator: 'ENDINET G',
        captarCode: '8742050202110',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716902000001',
        gridoperator: 'ENDURIS E',
        captarCode: '8742040102116',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8717127750009',
        gridoperator: 'ENDURIS E',
        captarCode: '8742040102116',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716902000001',
        gridoperator: 'ENDURIS G',
        captarCode: '8742040202113',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8717127750009',
        gridoperator: 'ENDURIS G',
        captarCode: '8742040202113',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716925000002',
        gridoperator: 'schiedam E',
        captarCode: '8742031102118',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716925000002',
        gridoperator: 'schiedam G',
        captarCode: '8742031202115',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716879000004',
        gridoperator: 'ENEXIS G',
        captarCode: '8742010202112',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716885000005',
        gridoperator: 'ENEXIS G',
        captarCode: '8742010202112',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716897000000',
        gridoperator: 'ENEXIS G',
        captarCode: '8742010202112',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716904000009',
        gridoperator: 'ENEXIS G',
        captarCode: '8742010202112',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716909000004',
        gridoperator: 'ENEXIS G',
        captarCode: '8742010202112',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716948000003',
        gridoperator: 'ENEXIS G',
        captarCode: '8742010202112',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8717421000008',
        gridoperator: 'ENEXIS G',
        captarCode: '8742010202112',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716879000004',
        gridoperator: 'ENEXIS E',
        captarCode: '8742010102115',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716885000005',
        gridoperator: 'ENEXIS E',
        captarCode: '8742010102115',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716897000000',
        gridoperator: 'ENEXIS E',
        captarCode: '8742010102115',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716904000009',
        gridoperator: 'ENEXIS E',
        captarCode: '8742010102115',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716909000004',
        gridoperator: 'ENEXIS E',
        captarCode: '8742010102115',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716948000003',
        gridoperator: 'ENEXIS E',
        captarCode: '8742010102115',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8717421000008',
        gridoperator: 'ENEXIS E',
        captarCode: '8742010102115',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716874000009',
        gridoperator: 'Stedin G',
        captarCode: '8742030202116',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716886000004',
        gridoperator: 'Stedin G',
        captarCode: '8742030202116',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716892700004',
        gridoperator: 'Stedin G',
        captarCode: '8742030202116',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716892710003',
        gridoperator: 'Stedin G',
        captarCode: '8742030202116',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716892720002',
        gridoperator: 'Stedin G',
        captarCode: '8742030202116',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716892740000',
        gridoperator: 'Stedin G',
        captarCode: '8742030202116',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716892750009',
        gridoperator: 'Stedin G',
        captarCode: '8742030202116',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716921000006',
        gridoperator: 'Stedin G',
        captarCode: '8742030202116',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716924000003',
        gridoperator: 'Stedin G',
        captarCode: '8742030202116',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716946000005',
        gridoperator: 'Stedin G',
        captarCode: '8742030202116',
        energytype: enums_1.EnergyType.GAS,
    },
    {
        gridcompanyEAN: '8716924000003',
        gridoperator: 'Stedin E',
        captarCode: '8742030102119',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716874000009',
        gridoperator: 'Stedin E',
        captarCode: '8742030102119',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716886000004',
        gridoperator: 'Stedin E',
        captarCode: '8742030102119',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716892700004',
        gridoperator: 'Stedin E',
        captarCode: '8742030102119',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716892710003',
        gridoperator: 'Stedin E',
        captarCode: '8742030102119',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716892720002',
        gridoperator: 'Stedin E',
        captarCode: '8742030102119',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716892740000',
        gridoperator: 'Stedin E',
        captarCode: '8742030102119',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716892750009',
        gridoperator: 'Stedin E',
        captarCode: '8742030102119',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716921000006',
        gridoperator: 'Stedin E',
        captarCode: '8742030102119',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
    {
        gridcompanyEAN: '8716946000005',
        gridoperator: 'Stedin E',
        captarCode: '8742030102119',
        energytype: enums_1.EnergyType.ELECTRICITY,
    },
];
